module.exports = __webpack_public_path__ + "img/compentation_gift_primary.28b829c4.svg";